/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_3_DescInputs */

const en_mk_agent_3_desc = /** @type {(inputs: Mk_Agent_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not every piece of work deserves an issue. For the small ones, mention the agent mid-conversation — the answer sticks to that same thread, not to a separate chat box.`)
};

const id_mk_agent_3_desc = /** @type {(inputs: Mk_Agent_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak semua pekerjaan pantas jadi issue. Untuk yang kecil, sebut agennya di tengah obrolan divisi — jawabannya menempel di percakapan yang sama, bukan di kotak chat terpisah.`)
};

/**
* | output |
* | --- |
* | "Not every piece of work deserves an issue. For the small ones, mention the agent mid-conversation — the answer sticks to that same thread, not to a separate ..." |
*
* @param {Mk_Agent_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_3_desc = /** @type {((inputs?: Mk_Agent_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_3_desc(inputs)
	return en_mk_agent_3_desc(inputs)
});